const styles = require('../components/MailListItem.scss');
import MailListItemDataProps from '../utils/types/MailListItemDataProps';
import MailListTableProps from '../utils/types/MailListTableProps';

export default function getBackgroundColorClass(
    itemProps: MailListItemDataProps,
    tableProps: MailListTableProps,
    isChecked: boolean
) {
    if (itemProps.isSelected || isChecked) {
        return styles.selectedMailListItemColor;
    } else if (tableProps.supportsFlagging && itemProps.isFlagged) {
        return styles.flaggedMailListItemColor;
    } else if (tableProps.supportsPinning && itemProps.isPinned) {
        return styles.pinnedMailListItemColor;
    } else {
        return styles.regularMailListItemColor;
    }
}
